import { i18n } from '@/shared/i18n';

/**
 * Deliberately not an `IqDataSource`: every id in that generated union names a source the
 * backend can actually connect, and `hasDataSourceAccess` would refuse this one.
 */
export type StatistaPlaceholder = 'statista';

export const STATISTA_PLACEHOLDER_ID: StatistaPlaceholder = 'statista';

/** Single-letter mark shown in place of a logo, as the real data sources do. */
export const STATISTA_PLACEHOLDER_MARK = 'S';

// A getter, not a value: resolving the label at import freezes its copy before i18n is ready.
export const STATISTA_PLACEHOLDER_COPY = {
  get label() {
    return i18n.t('knowledge:dataSource.statista.label');
  },
};
